import { Attribute } from 'src/app/shared/models/domain/attribute';
import { ObjectWrapper } from 'src/app/shared/wrappers/object.wrapper';
import { DIMsgObj } from 'src/app/shared/models/dimsgobj';
import { ArrayUtil } from 'src/app/shared/models/utils/array.util';
import { Business_GlossaryUtil } from './business_glossary.util';
import { ObjectWrapperUtil } from 'src/app/shared/utils/object.wrapper.util';
import { DatabaseEnum } from 'src/app/shared/databases/databases.enum';
import { CommonEnums } from 'src/app/shared/common.enums';
import { Datatype } from 'src/app/shared/databases/datatype';
import { DatabaseWrappersFactory } from 'src/app/shared/databases/database.wrappers.factory';
import { Util } from 'src/app/shared/utils/util';
import { ObjectUtil } from 'src/app/shared/utils/object.util';

export class Business_GlossaryComplexGridUtil {
    private static instance: Business_GlossaryComplexGridUtil;

    static getInstance() {
        if (!Business_GlossaryComplexGridUtil.instance) {
            Business_GlossaryComplexGridUtil.instance = new Business_GlossaryComplexGridUtil();
        }

        return Business_GlossaryComplexGridUtil.instance;
    }

    util: Util;
    business_glossaryUtil: Business_GlossaryUtil;
    objectWrapperUtil: ObjectWrapperUtil;
    databaseWrappersFactory: DatabaseWrappersFactory;

    /**
      * AttributesComplexGridUtil is a singleton class, so use AttributesComplexGridUtil.getInstance() method instead of creating new AttributesComplexGridUtil().
      */
    private constructor() {
        this.util = Util.getInstance();
        this.business_glossaryUtil = Business_GlossaryUtil.getInstance();
        this.objectWrapperUtil = ObjectWrapperUtil.getInstance();
        this.databaseWrappersFactory = DatabaseWrappersFactory.getInstance();
    }

    add(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>,
        objectWrapper: ObjectWrapper, attrType_Cd: string): DIMsgObj {
        let diMsgObj: DIMsgObj = new DIMsgObj();
        let selectedAttribute: Attribute;
        let selectedIndex: number = attributes.length;

        if (selectedAttributes.length > 0) {
            let parent_Attr_Id: number = selectedAttributes[0].parent_Attr_Id;
            for (let i: number = 1; i < selectedAttributes.length; i++) {
                if (selectedAttributes[i].parent_Attr_Id != parent_Attr_Id) {
                    diMsgObj.error_Msg = "To add complex attribute, please select one attribute or same group attributes.";
                    return diMsgObj;
                }
            }

            selectedAttributes = ArrayUtil.getInstance().sortBySrt_Order(selectedAttributes);
            selectedAttribute = selectedAttributes[selectedAttributes.length - 1];

            let childAttributes: Array<Attribute> = this.business_glossaryUtil.getChildAttributes(selectedAttribute, attributes);
            selectedIndex = childAttributes.length + selectedAttribute.srt_Order + 1;
        }

        diMsgObj.retMsgObject = this._addNewComplexAttribute(selectedIndex, selectedAttribute, attributes, objectWrapper, attrType_Cd);
        return diMsgObj;
    }

    private _addNewComplexAttribute(selectedIndex: number, selectedAttribute: Attribute, attributes: Array<Attribute>,
        objectWrapper: ObjectWrapper, attrType_Cd: string): Attribute {

        let parent_Attr_Id: number = -1;
        let srt_Order: number = attributes.length;
        let clevel: number = 0;
        if (selectedAttribute) {
            parent_Attr_Id = selectedAttribute.parent_Attr_Id;
            srt_Order = selectedAttribute.srt_Order + 1;
            clevel = selectedAttribute.clevel;
        }
      
        let attributeNew: Attribute = this.business_glossaryUtil.getNewAttribute(objectWrapper, attrType_Cd, parent_Attr_Id);

        attributeNew.attrType_Cd = attrType_Cd;
        attributeNew.srt_Order = srt_Order;
        attributeNew.valid_Cd = "0";
        attributeNew.error_Msg = this.objectWrapperUtil.getError_Msg(attributeNew.valid_Cd);

        attributeNew.parent_Attr_Id = parent_Attr_Id;
        attributeNew.clevel = clevel;

        if (objectWrapper.dbTyp_Id == DatabaseEnum.cobol.ID) {
            let cLevels: Array<number> = this.business_glossaryUtil.getCLevels(attributes);

            if (cLevels.length > 0)
                attributeNew.clevel = cLevels[0];
        }

        if (attrType_Cd == CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE) {
            attributeNew.attrType_Cd = CommonEnums.attrType_Cd.DERIVED_ATTRIBUTE;
            attributeNew.valid_Cd = 'EMPT_COND';
            attributeNew.error_Msg = this.objectWrapperUtil.getError_Msg(attributeNew.valid_Cd);
        }

        this.business_glossaryUtil.insert(attributeNew, attributes, objectWrapper, selectedIndex);
        objectWrapper.doValidate();

        return attributeNew;
    }

    getAdditionalAttrNm(dataType: Datatype, index: number, attrNm: string): string {
        let additionalNames = String(dataType.additionalNames).split(',');

        if (additionalNames.length == 1 && additionalNames[0] == 'ARRAY') {
            return "__" + attrNm;
        }

        if (additionalNames.length > index)
            return additionalNames[index] == "" ? attrNm : additionalNames[index]

        return attrNm;
    }

    attrDTyp_IdChanged(attribute: Attribute, attributes: Array<Attribute>,
        objectWrapper: ObjectWrapper, oldAttrDTyp_Id: number): void {

        let nativeDbTyp_Id: number = objectWrapper.nativeDbTyp_Id == -2 ? objectWrapper.dbTyp_Id : objectWrapper.nativeDbTyp_Id;

        let datatype: Datatype = this.databaseWrappersFactory.getDatatype(nativeDbTyp_Id, attribute.attrDTyp_Id);
        if (!datatype) return;

        attribute.attrPrec = datatype.defaultprecision;
        attribute.attrScale = datatype.defaultscale;

        if (datatype.hasOwnProperty('minprec') &&
            datatype.hasOwnProperty('minscale')) {
            attribute.minAttrPrec = datatype.minprec;
            attribute.minAttrScale = datatype.minscale;
        }

        let oldDatatype: Datatype = this.databaseWrappersFactory.getDatatype(objectWrapper.nativeDbTyp_Id, oldAttrDTyp_Id);
        if (!oldDatatype) return;

        if (oldDatatype.additionalRows != '') {
            let childAttributes: Array<Attribute> = this.business_glossaryUtil.getChildAttributes(attribute, attributes);
            this.business_glossaryUtil.remove(childAttributes, attributes, objectWrapper);
        }

        if (datatype.additionalRows != '') {
            let additionalRows: number = parseInt(datatype.additionalRows);

            for (let i: number = 0; i < additionalRows; i++) {
                let attributeNew: Attribute = new Attribute();
                attributeNew.obj_Id = objectWrapper.obj_Id;
                attributeNew.attr_Id = this.objectWrapperUtil.getNewSub_Id(objectWrapper);
                attributeNew.attrNm = this.util.getNewName(this.getAdditionalAttrNm(datatype, i, attribute.attrNm), objectWrapper.subNames);

                let datatypeTmp = this.databaseWrappersFactory.getDefaultDatatype(objectWrapper.nativeDbTyp_Id);
                if (datatypeTmp) {
                    attributeNew.attrDTyp_Id = datatypeTmp.id;
                    attributeNew.attrPrec = datatypeTmp.defaultprecision;
                    attributeNew.attrScale = datatypeTmp.defaultscale;
                }

                attributeNew.attrType_Cd = CommonEnums.attrType_Cd.ATTRIBUTE;
                attributeNew.valid_Cd = '0';

                attributeNew.clevel = attribute.clevel + 5;
                attributeNew.parent_Attr_Id = attribute.attr_Id;

                attributeNew.srt_Order = attribute.srt_Order + i + 1;

                this.business_glossaryUtil.setAttributeReadOnlyProperties(attributeNew, objectWrapper);

                this.business_glossaryUtil.insertAt(attributeNew, attributes, attributeNew.srt_Order, objectWrapper);
            }
        }

        if (objectWrapper.hasOwnProperty('designWrapper')) {
            //TODO
        }

        objectWrapper.doValidate();
    }

    up(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper): Array<number> {
        let selectedAttr_Ids: Array<number> = new Array<number>();
        let selectedAttributesTmp: Array<Attribute> = new Array<Attribute>();

        for (let i: number = 0; i < selectedAttributes.length; i++) {
            let selectedAttribute: Attribute = selectedAttributes[i];

            selectedAttr_Ids.push(selectedAttribute.attr_Id);

            if (selectedAttribute.srt_Order == 0) continue;

            let attributeAbove: Attribute = attributes[selectedAttribute.srt_Order - 1];
            if (attributeAbove.clevel < selectedAttribute.clevel) continue;

            selectedAttributesTmp.push(selectedAttribute);
        }

        if (selectedAttributesTmp.length == 0) {
            return selectedAttr_Ids;
        }

        this.business_glossaryUtil.appendChildAttributes(selectedAttributesTmp, attributes);
        let upJumpCountsMap: Map<number, number> = this.business_glossaryUtil.getUpJumpCountsMap(selectedAttributesTmp, attributes);

        for (let i: number = 0; i < selectedAttributesTmp.length; i++) {
            let selectedAttributeTmp: Attribute = selectedAttributesTmp[i];
            let srt_Order: number = selectedAttributeTmp.srt_Order;
            let jumpCount: number = upJumpCountsMap.get(selectedAttributeTmp.attr_Id);

            let deletedAttributes: Array<Attribute> = attributes.splice(srt_Order, 1);
            attributes.splice(srt_Order - jumpCount, 0, deletedAttributes[0]);

            deletedAttributes[0].srt_Order--;
            attributes[srt_Order].srt_Order++;
        }

        ObjectUtil.getInstance().resetSrt_Order(attributes);

        return selectedAttr_Ids;
    }

    down(selectedAttributes: Array<Attribute>, attributes: Array<Attribute>, objectWrapper: ObjectWrapper): Array<number> {
        let selectedAttr_Ids: Array<number> = new Array<number>();
        let selectedAttributesTmp: Array<Attribute> = new Array<Attribute>();
        let index: number = 0;

        for (let i: number = selectedAttributes.length - 1; i >= 0; i--) {
            let selectedAttribute: Attribute = selectedAttributes[i];
            selectedAttr_Ids.push(selectedAttribute.attr_Id);

            index++;
            if (selectedAttribute.srt_Order == attributes.length - index) continue;

            selectedAttributesTmp.push(selectedAttribute);
        }
        if (selectedAttributesTmp.length == 0) return;

        for (let i: number = 0; i < selectedAttributesTmp.length; i++) {
            let selectedAttribute: Attribute = selectedAttributesTmp[i];
            let srt_Order: number = selectedAttribute.srt_Order;

            let deletedAttributes: Array<Attribute> = attributes.splice(srt_Order, 1);
            attributes.splice(srt_Order + 1, 0, deletedAttributes[0]);

            deletedAttributes[0].srt_Order++;
            attributes[srt_Order].srt_Order--;
        }
        return selectedAttr_Ids;
    }
}